import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fixed bg-white p-6 md:p-8 shadow-md max-w-md z-50 inset-x-0 top-0 md:top-8 m-auto max-h-screen overflow-auto" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close Modal", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconX = _resolveComponent("IconX")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, {
      "enter-active-class": "transition-all transform transition-fastest ease-out-quad",
      "leave-active-class": "transition-all transform transition-fastest ease-in-quad",
      "enter-from-class": "opacity-0 -translate-y-12",
      "enter-to-class": "opacity-100 -translate-y-0",
      "leave-from-class": "opacity-100 -translate-y-0",
      "leave-to-class": "opacity-0 -translate-y-12"
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_1, [
          _createElementVNode("button", {
            class: "h-12 w-12 flex items-center justify-center -mt-6 md:-mt-8 float-right -mr-6 md:-mr-8",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
          }, [
            _createVNode(_component_IconX, { class: "h-6 w-6" }),
            _hoisted_2
          ]),
          _renderSlot(_ctx.$slots, "default")
        ], 512), [
          [_vShow, _ctx.isOpen]
        ])
      ]),
      _: 3
    }),
    _createVNode(_Transition, {
      "enter-active-class": "transition-opacity transition-fastest ease-out-quad",
      "leave-active-class": "transition-opacity transition-fastest ease-in-quad",
      "enter-from-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          class: "bg-black cursor-pointer fixed inset-0 z-40 bg-opacity-75",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
        }, null, 512), [
          [_vShow, _ctx.isOpen]
        ])
      ]),
      _: 1
    })
  ], 64))
}